// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-iVBVa";
var _3 = "header-1bJhg";
var _4 = "header__icon-1z-l4";
var _5 = "root_meal-3Lut4";
var _6 = "root_transfer-3zHwW";
var _7 = "root_animal-5GU4c";
var _8 = "root_businessLounge-33BdZ";
var _9 = "root_loyalty-2RECR";
var _a = "root_sms-2fc2Y";
var _b = "root_baggage-XO91W";
var _c = "root_seats-2mbaI";
var _d = "root_insurance-2flY0";
var _e = "icons-3t5If";
var _f = "root_upgrade-24epP";
var _10 = "root_priorityBoarding-2YJVR";
var _11 = "root_refundableTicket-1MSqe";
var _12 = "root_capsuleHotel-ia_6A";
var _13 = "title-24c80";
var _14 = "buttonStatus-hp-sO";
var _15 = "buttonStatus_selected-3FPam";
var _16 = "content-3hW3x";
var _17 = "description-I5KO8";
var _18 = "controls-1fFt5";
var _19 = "footer-3TyLX";
var _1a = "footer__price-QR4rQ";
export { _1 as "__esModule", _2 as "root", _3 as "header", _4 as "header__icon", _5 as "root_meal", _6 as "root_transfer", _7 as "root_animal", _8 as "root_businessLounge", _9 as "root_loyalty", _a as "root_sms", _b as "root_baggage", _c as "root_seats", _d as "root_insurance", _e as "icons", _f as "root_upgrade", _10 as "root_priorityBoarding", _11 as "root_refundableTicket", _12 as "root_capsuleHotel", _13 as "title", _14 as "buttonStatus", _15 as "buttonStatus_selected", _16 as "content", _17 as "description", _18 as "controls", _19 as "footer", _1a as "footer__price" }
export default { "__esModule": _1, "root": _2, "header": _3, "header__icon": _4, "root_meal": _5, "root_transfer": _6, "root_animal": _7, "root_businessLounge": _8, "root_loyalty": _9, "root_sms": _a, "root_baggage": _b, "root_seats": _c, "root_insurance": _d, "icons": _e, "root_upgrade": _f, "root_priorityBoarding": _10, "root_refundableTicket": _11, "root_capsuleHotel": _12, "title": _13, "buttonStatus": _14, "buttonStatus_selected": _15, "content": _16, "description": _17, "controls": _18, "footer": _19, "footer__price": _1a }
